import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	padding: 16px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${tokens.color_gray_dark};
	font-size: 14px;
	font-weight: 500;
`;
